import * as React from "react";
type Props = {
  className?: string,
};
function SvgSweets710({ className }: Props) {
  return (
    <svg
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-sweets-7-10"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4116 44.5641C1.88878 39.0072 -3.23978 16.7781 7.43162 15.6633C18.103 14.5481 23.8074 -3.5993 36.3974 2.4204C48.9879 8.4401 48.9869 26.5011 44.7897 33.9111C40.5931 41.3212 28.9345 50.121 15.4116 44.5641Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4116 44.5641C1.88878 39.0072 -3.23978 16.7781 7.43162 15.6633C18.103 14.5481 23.8074 -3.5993 36.3974 2.4204C48.9879 8.4401 48.9869 26.5011 44.7897 33.9111C40.5931 41.3212 28.9345 50.121 15.4116 44.5641Z"
        fill="#D6E4EE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2226 13.3278C30.8031 14.237 30.8218 15.1997 30.8594 16.2553C30.8853 16.9901 31.1708 17.5586 31.537 18.1822C32.0244 19.0125 31.8808 19.8855 31.9573 20.819C32.0196 21.5804 32.3142 23.1276 33.6954 22.8337C35.5157 22.4477 35.1373 21.6892 39.9559 20.6353C40.786 20.4533 42.0048 20.558 42.6731 19.8445C43.2464 19.2332 43.7149 18.6468 44.0535 17.5857C44.253 16.9618 44.202 16.2469 44.0317 15.7775C43.7818 15.0907 43.2262 14.5403 42.9087 13.8815C42.5868 13.2131 42.7869 12.5339 42.7607 11.81C42.7281 10.9016 42.0141 10.2531 41.5257 9.5145C40.9469 8.63673 41.1371 7.66456 41.0527 6.65523C40.9837 5.82469 40.855 3.96349 39.4404 3.84467C38.4684 3.76393 37.3864 4.55028 36.5061 4.87888C35.7317 5.16714 34.593 5.55664 33.7905 5.70551C32.9481 5.86149 32.414 5.75639 31.6366 6.15582C29.9643 7.01384 28.8366 9.46589 28.8038 10.5945C28.7743 11.5872 29.6964 12.5036 30.2226 13.3278Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.7894 5.70579C34.5925 5.55672 35.7313 5.16722 36.5057 4.87897C37.3859 4.55036 38.4686 3.7638 39.44 3.84475C40.8552 3.96337 40.9833 5.82477 41.0522 6.65531C41.1367 7.66464 40.9464 8.63681 41.5259 9.51437C42.0136 10.2531 42.7277 10.9017 42.7602 11.8101C42.7864 12.534 42.5864 13.2132 42.9082 13.8816C43.2257 14.5404 43.7812 15.0902 44.0312 15.7775C44.2016 16.247 44.3998 16.8857 44.0785 17.4199C43.6228 18.1787 42.2084 18.0722 41.3781 18.2535C36.5594 19.3074 36.9385 20.0656 35.1178 20.4525C33.7363 20.7458 33.4424 19.1984 33.3794 18.4371C33.3031 17.5044 33.4466 16.6307 32.959 15.7997C32.5932 15.1775 32.3075 14.6083 32.2815 13.8734C32.2439 12.8179 32.2252 11.8552 31.6448 10.946C31.1186 10.1218 30.337 9.37563 30.242 8.38622C30.1642 7.57433 30.4824 6.67186 31.6355 6.1561C32.4344 5.79868 32.9477 5.86157 33.7894 5.70579Z"
        stroke="currentColor"
      />
      <path
        d="M38.3712 6.55049C39.6146 9.61601 34.2384 9.56077 34.1161 12.4446"
        stroke="currentColor"
      />
      <path
        d="M40.1991 10.8423C41.4433 13.9083 36.0671 13.8531 35.9449 16.7369"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2909 34.2374C35.2909 34.9556 34.2399 35.5308 34.07 36.1938C33.8938 36.8823 34.5318 37.8924 34.1972 38.4969C33.8554 39.1138 32.6585 39.1066 32.1774 39.6083C31.6925 40.1148 31.7492 41.3107 31.15 41.6732C30.5551 42.0328 29.5272 41.4269 28.846 41.617C28.1854 41.8019 27.6217 42.8581 26.9045 42.8581C26.1867 42.8581 25.6231 41.8019 24.962 41.617C24.2812 41.4269 23.2528 42.0323 22.6584 41.6727C22.0593 41.3107 22.1155 40.1148 21.631 39.6083C21.15 39.1066 19.9531 39.1133 19.6112 38.4964C19.2766 37.8924 19.9147 36.8823 19.7385 36.1938C19.5685 35.5308 18.5176 34.9556 18.5176 34.2374C18.5176 33.5196 19.5685 32.9445 19.7385 32.281C19.9147 31.5925 19.2766 30.5829 19.6112 29.9784C19.9531 29.3615 21.15 29.3682 21.631 28.866C22.1159 28.36 22.0593 27.1641 22.6584 26.8021C23.2533 26.4425 24.2812 27.0479 24.9625 26.8578C25.6231 26.6734 26.1867 25.6172 26.9045 25.6172C27.6217 25.6172 28.1854 26.6734 28.8465 26.8582C29.5272 27.0479 30.5556 26.4425 31.15 26.8021C31.7492 27.1641 31.693 28.3605 32.1774 28.866C32.6585 29.3687 33.8554 29.3615 34.1972 29.9784C34.5318 30.5829 33.8938 31.5925 34.07 32.281C34.2399 32.9445 35.2909 33.5196 35.2909 34.2374Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2129 29.5896C30.2129 29.5896 25.8133 26.7916 22.2456 31.1168C22.2456 31.1168 19.4591 35.1137 22.7243 38.1182C22.7243 38.1182 25.2938 40.3583 28.545 39.63C28.545 39.63 31.6863 39.05 32.5328 36.3759C33.2692 34.0488 33.3331 31.5192 30.2129 29.5896Z"
        stroke="currentColor"
      />
      <path
        d="M26.9475 35.4868C27.4938 35.1215 29.5453 32.3105 28.1448 32.1991C27.2662 32.13 26.4011 33.166 25.1821 33.1271"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2257 10.829C18.9651 10.7517 18.7068 10.9108 18.6571 10.942C18.4386 11.0771 18.2176 11.3542 18.2636 11.6784C18.3139 12.0283 18.6378 12.1812 18.6583 12.19C18.9734 12.3318 19.3798 12.2283 19.5811 11.9716C19.8882 11.5785 19.6253 10.947 19.2257 10.829Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9112 14.2369C22.5721 14.1305 22.2405 14.3398 22.1756 14.3801C21.8945 14.5565 21.6111 14.9228 21.6757 15.3552C21.745 15.8214 22.1662 16.0286 22.193 16.0408C22.6034 16.2333 23.1283 16.1007 23.3858 15.7611C23.779 15.2423 23.4305 14.3995 22.9112 14.2369Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9169 8.98723C22.6723 9.2282 22.699 9.60574 22.7041 9.67904C22.7265 9.99869 22.9099 10.4069 23.3078 10.5485C23.7359 10.7016 24.1036 10.4369 24.127 10.4197C24.478 10.158 24.6035 9.65021 24.4313 9.27638C24.1685 8.70564 23.2914 8.61905 22.9169 8.98723Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1573 20.7458C19.8226 20.5467 19.7672 20.4687 19.5173 20.3149C19.2956 20.1794 18.9506 19.9675 18.5145 19.9099C18.2142 19.8702 18.2369 19.9524 17.6579 19.9794C17.0869 20.0061 16.7608 20.0169 16.4611 19.8169C16.2559 19.6805 16.1476 19.5012 16.0549 19.3487C15.8425 18.999 15.9021 18.8304 15.6618 18.4065C15.5889 18.2776 15.5053 18.1294 15.3534 17.9752C15.1197 17.7386 14.966 17.7307 14.5588 17.5023C14.1036 17.2469 13.8363 17.097 13.6976 16.7926C13.5945 16.566 13.603 16.3431 13.6112 16.1362C13.622 15.8469 13.6857 15.7907 13.7635 15.3852C13.8417 14.9752 13.8881 14.7348 13.8313 14.4395C13.7911 14.2274 13.6963 14.0533 13.5067 13.7045C13.2244 13.1859 13.1501 13.2103 13.0682 12.9456C13.0361 12.8398 12.9083 12.3829 13.1121 11.9546C13.1683 11.835 13.2533 11.7349 13.4221 11.535C13.6649 11.2476 13.8054 11.1613 13.9079 10.9287C13.9731 10.781 13.9912 10.6482 13.9974 10.5656C13.6091 10.5192 13.2161 10.4918 12.8137 10.5038C8.38056 10.6339 4.89194 14.3332 5.02191 18.7668C5.15197 23.1995 8.85173 26.6887 13.285 26.5582C16.7656 26.4559 19.6547 24.1507 20.677 21.0203C20.5512 20.962 20.3693 20.8719 20.1573 20.7458Z"
        fill="white"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94475 17.7001C7.595 17.8105 7.43015 18.1864 7.39833 18.2598C7.25843 18.5782 7.22481 19.0593 7.5259 19.3914C7.84966 19.7489 8.32718 19.6751 8.35748 19.6703C8.81755 19.591 9.1899 19.1655 9.21677 18.7217C9.25759 18.0445 8.4805 17.5299 7.94475 17.7001Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0549 21.282C12.5977 21.4203 12.3865 21.9042 12.346 21.9978C12.1667 22.4073 12.1288 23.0285 12.5277 23.4612C12.957 23.9265 13.5818 23.8373 13.6217 23.8313C14.2241 23.7351 14.707 23.1903 14.7362 22.6177C14.7808 21.7437 13.7557 21.0694 13.0549 21.282Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6903 14.2655C8.60044 14.7178 8.91599 15.1178 8.97697 15.1949C9.24409 15.5339 9.75633 15.8487 10.3061 15.706C10.8982 15.5522 11.1066 14.9794 11.1193 14.9431C11.3114 14.3858 11.0674 13.7266 10.5924 13.4415C9.86862 13.0057 8.82811 13.5725 8.6903 14.2655Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgSweets710;
